import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { QueryOperatorTypeString } from 'src/app/shared/interfaces/graphql.interface';

import { IFilterItem } from './../../filter.interface';

@Component({
  selector:
    '[formGroup] textbox-filter-item,[formGroupName] textbox-filter-item',
  templateUrl: './textbox-filter-item.component.html',
})
export class TextboxFilterItemComponent implements OnInit {
  @Input() filterItem: IFilterItem;

  public filtersForm: UntypedFormGroup;

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.filtersForm = this.controlContainer.control as UntypedFormGroup;
  }

  onOperatorSelect(operatorName: QueryOperatorTypeString) {
    this.filterItem.queryOperator = operatorName;
  }
}
